// Visual state associated with a Unit during combat. Separated from Unit so
// combat logic stays pure and rendering doesn't need to mutate the data model.

import type { Unit } from "../units/Unit";

export class UnitVisual {
  x: number;
  y: number;
  lungeX = 0; // offset added on top of lerped position (set by AttackAnim)
  lungeY = 0;
  scale = 1;
  alpha = 1;
  hitFlash = 0;  // 0..1 red overlay
  healFlash = 0; // 0..1 green overlay
  bobOffset = 0;
  shakeX = 0;
  rotation = 0; // radians — used by Katarina spin
  overrideIconUrl: string | null = null; // temporarily swap sprite (e.g. Nidalee cougar form)
  dead = false;
  // Vayne Silver Bolts ring count, lags the data-side stack count so additions can be
  // staggered visually by ~150ms each. Reset to 0 after the proc pop animates.
  vayneVisualStacks = 0;

  constructor(
    public readonly unit: Unit,
    initialX: number,
    initialY: number,
  ) {
    this.x = initialX;
    this.y = initialY;
  }
}
